import * as React from 'react';
import Tag from 'antd/lib/tag';
import { antGrey, runwayColors, tagStyle } from '../styles/globalStyles';
import { FeatureFlagStatus } from '../../types';
import { featureFlagStatusDisplayString } from '../../helpers/displayHelpers';

export interface FeatureFlagStatusProps {
    status: FeatureFlagStatus;
    fill?: boolean;
}

export const FeatureFlagStatusTag: React.FC<FeatureFlagStatusProps> = (props) => {
    const { status, fill } = props;
    let textColor;
    if (fill) {
        textColor = 'white';
    } else {
        textColor = status === FeatureFlagStatus.Enabled ? runwayColors.statusGreen : antGrey.grey6;
    }

    let fillColor;
    if (fill) {
        fillColor = status === FeatureFlagStatus.Enabled ? runwayColors.statusGreen : antGrey.grey6;
    } else {
        fillColor = null;
    }

    return (
        <Tag
            color={runwayColors.white}
            style={{
                ...tagStyle,
                fontSize: 10,
                borderColor: status === FeatureFlagStatus.Enabled ? runwayColors.statusGreen : antGrey.grey6,
                backgroundColor: fillColor,
                color: textColor,
            }}
        >
            {featureFlagStatusDisplayString(status)}
        </Tag>
    );
};
